module.exports = __webpack_public_path__ + "img/拉伸3.2bdad60b.svg";